import { useQuery } from 'react-query';
import { EventCategoryAPI } from 'api/admin/eventCategory';
import { EVENT_CATEGORIES } from 'helpers/constants';

export default function useEventCategories() {
  return useQuery(EVENT_CATEGORIES, EventCategoryAPI.getAll);
}
